import { createContext, useContext, useReducer } from 'react'
import { reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

SequencedFormDataContext = createContext()

initialState = {
  formData: {},
}

export SequencedFormDataProvider = ({ children }) ->
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <SequencedFormDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </SequencedFormDataContext.Provider>

export useSequencedFormData = () ->
  useContext(SequencedFormDataContext)
